<template>
  <span class="material-symbols-outlined">forum</span>
</template>
